<template>
  <div ref="component" class="vue-translations" style="align-items: stretch; display:none">
      <div class="prices">
          <div class="component-header"> {{ header }}</div>
          <topup-number :countryPhonePrefix="model.CountryPhonePrefix" :country="country" />
          <topup-prices :availableTopupOptions="model.AvailableTopupOptions" />
      </div>
  </div>
</template>

<script lang="ts">
import TopupNumber from './general/topup/topupNumber.vue';
import TopupPrices from './general/topup/topupPrices.vue';
import {TopupAmountsViewModel} from './Models/TopupAmountsViewModel';
import { fmComponentsContainer } from './../topic-components';

export default {
  name: "TopupWithPrices",
  data: function () {
    return {
        Urls: {
            FetchInitialDataUrl: "/vue/components/topup/prices/fetch"
        },
        FetchInitialDataReady: false,
        FetchTranslationsReady: false,
        model: {} as TopupAmountsViewModel,
    }
  },
  /* Initial parameters  */
  props: {
    country: String,
    mobileOperator: String,
    header: String,
    currencies: Array<String>
  },
  components: {
    "TopupNumber": TopupNumber,
    "TopupPrices": TopupPrices,
  },
  beforeMount() {
    this.model = new TopupAmountsViewModel();
  },
  mounted() {
    fmComponentsContainer.$on('translationsFetched', this.handleTranslationsReady);

    this.fetchInitialData();
  },
  methods: {
    fetchInitialData() {

      if (this.Urls.FetchInitialDataUrl) {

        if (this.Urls.FetchInitialDataUrl) {
          fetch(this.Urls.FetchInitialDataUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              country: this.country,
              mobileOperator: this.mobileOperator,
              currencies: this.currencies
            })
          })
              .then(response => {
                return response.json();
              })
              .then(response => {
                this.model = response;

                this.FetchInitialDataReady = true;
                this.handleInitialDataUpdated();
              });
        }
      }
    },
    handleTranslationsReady() {
      this.FetchTranslationsReady = true;
      this.handleInitialDataUpdated();
    },
    handleInitialDataUpdated() {
      if (this.FetchInitialDataReady && this.FetchTranslationsReady) {

        var parent = this.$refs.component.parentElement;

        const preloader = parent.querySelector('.component-preloader');

        if (preloader)
          preloader.remove();

        this.$refs.component.style.display = "block";
      }
    },
  }
}

</script>

